import{a as o}from"./chunk-5HMS5KVK.js";import{m as n}from"./chunk-HBP5N4FR.js";n();var R=75,E=25,i=100,D=({remaining:e,totalSeconds:r,isCrossShard:s})=>{let c=s?E:R,S=i/1e3,t=1/(r*S),_=Math.min(o(e)-1,t),a=e>=100-c?t:_;return e-a};export{R as a,E as b,i as c,D as d};
//# sourceMappingURL=chunk-XAQNBFSL.js.map
